import { prependStaticClass } from './helpers'

export default {
  name: 'Row',
  functional: true,
  props: {
    element: {
      type: String,
      default: 'div'
    },
    center: {
      type: String,
      default: null,
      validator: (value) => value.match(/xs|sm|md|lg|xl|all/)
    }
  },
  render: (createElement, context) => {
    const addedClasses = ['row']
    const centerProp = context.props.center
    if (centerProp) centerProp === 'all' ? addedClasses.push(`justify-content-center`) : addedClasses.push(`justify-content-${centerProp}-center`)
    context.data.staticClass = prependStaticClass(context, addedClasses)
    return createElement(context.props.element, context.data, context.children)
  }
}
